import React from "react";

function SkeletonBlock({ className = "" }) {
  return (
    <div
      className={`animate-pulse rounded-[2rem] bg-slate-200 dark:bg-white/10 ${className}`}
    />
  );
}

function PrepaCoachSkeleton() {
  return (
    <div className="grid gap-5 lg:grid-cols-[1.2fr_0.8fr]">
      <div className="rounded-[2rem] border border-slate-200 bg-white p-6 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
        <SkeletonBlock className="h-8 w-56" />

        <div className="mt-6 space-y-4">
          <SkeletonBlock className="h-36" />
          <SkeletonBlock className="h-36" />
          <SkeletonBlock className="h-36" />
        </div>
      </div>

      <div className="space-y-5">
        <SkeletonBlock className="h-[520px]" />
        <SkeletonBlock className="h-[620px]" />
      </div>
    </div>
  );
}

export default PrepaCoachSkeleton;